export type ShipmentStatus = 'TEMP_LIMIT_EXCEEDED';

export const ShipmentStatuses: Record<ShipmentStatus, string> = {
  TEMP_LIMIT_EXCEEDED: 'Temperature limit exceeded',
};
